import { createApp } from 'vue'
import ExtRedirPage from './ExtRedirPage.vue'
// import { browserDetection } from '../../core/fm_app/src/utils'

// browserDetection();
// window.browserDetection = browserDetection();

const extPartnerRedirContainer = document.getElementById('ext-partner-redir');
if (extPartnerRedirContainer) {
  const extPartnerRedirApp = createApp(ExtRedirPage, {
    redirPage: (window.redirPage?window.redirPage:false)
  });
  extPartnerRedirApp.mount('#ext-partner-redir');
}